<div class="grid-x minor-margin-bottom clear-buttons">
    <div class="cell small-12 line-height-125-rem" *ngIf="hasCash || hasInstruments">
            <ng-container *ngIf="hasCash">
                <ul class="no-margin no-list-style" *ngFor="let item of cashItems.instruments">
					<li class="cash">
						<span>
							@switch (item.instrumentType) {
								@case ('PaidCash') {
									Cash in the amount of <b>{{item.instrumentAmount | currency: 'USD':'symbol':'1.2-2'}}</b>
									(<b>{{item.appliedAmount | currency: 'USD':'symbol':'1.2-2'}}</b> already applied)
								}
							}
						</span>
						<span>
							Received on {{ item.receivedDate | date }}
						</span>
					</li>
                </ul>
            </ng-container>
            <ng-container *ngIf="hasInstruments">
                <ul class="no-margin no-list-style" *ngFor="let item of nonCashItems.instruments">
					<li class="instrument">
						<span>
							@switch (item.instrumentType) {
								@case ('LocalCheck') {
									Check <b>#{{item.token}}</b> for <b>{{item.instrumentAmount | currency: 'USD':'symbol':'1.2-2'}}</b>
									(<b>{{item.appliedAmount | currency: 'USD':'symbol':'1.2-2'}}</b> already applied)
								}
								@case ('MoneyOrder') {
									Money Order <b>#{{item.token}}</b> for <b>{{item.instrumentAmount | currency: 'USD':'symbol':'1.2-2'}}</b>
									(<b>{{item.appliedAmount | currency: 'USD':'symbol':'1.2-2'}}</b> already applied)
								}
							}
						</span>
						<span>
							Received on {{ item.receivedDate | date }}
						</span>
					</li>
                </ul>
            </ng-container>
    </div>
</div>